// extracted by mini-css-extract-plugin
module.exports = {"container":"FormH2-module__container--JWcLF"};